/** @jsx jsx */

import { jsx } from '@emotion/core';
import { stripTrailingSlash } from '@zapier/url-utils';

import Item from './Item';
import { SIDEBAR_ITEMS } from './constants';

type Props = {
  versionlessUrl: string;
  currentUrl: string;
};

const SectionInsights = ({ currentUrl, versionlessUrl }: Props) => {
  const { key, name: label, section } = SIDEBAR_ITEMS.INSIGHTS;
  const url = `${versionlessUrl}/${key}`;
  const isActive = stripTrailingSlash(currentUrl) === url;

  return (
    <Item
      iconName="partnerDashboard"
      isActive={isActive}
      isEnabled={true}
      label={label}
      section={section}
      url={url}
    />
  );
};

export default SectionInsights;
